import DateUtility from "./lib/dateUtility";
import FetchHelper from "./lib/fetchHelper";
import React from "react";
import { ReactRenderer } from "./lib/ReactRenderer";
import AcquireShift, { overtagQuestion, whenText } from "./lib/acquireShift";
import CancelExchangeConfirm from "./lib/cancelExchangeConfirm";
import ShiftExchangeFormComponent from "./ShiftExchangeFormComponent";
import MyByttevagterPage from "./MyByttevagterPage";
import { SWAP_CHANGED_EVENT } from "./lib/swapShiftLine";
import { MoreButton, OwnShiftRow, parseAsSection, parseVisibleCount, RoleLabel, SectionHead, ShiftList, ShiftPageHead, ShiftRow } from "./lib/shiftList";
export default class ShiftExchangeListComponent extends React.Component {
    constructor(props) {
        super(props);
        this.load = () => {
            FetchHelper.get(`/bpapi/shiftexchange/`)
                .then((result) => {
                this.setState(Object.assign({ isLoaded: true }, result));
            });
        };
        this.limit = parseVisibleCount(this.props.visiblecount);
        this.asSection = parseAsSection(this.props.assection);
        this.state = {
            isLoaded: false,
            visible: this.limit,
            // The byttevagt whose Træk tilbage was pressed, while its confirmation is open.
            confirmCancel: null,
            // The byttevagt whose Overtag was pressed, while its question is open.
            confirmTake: null
        };
    }
    componentDidMount() {
        this.load();
        window.addEventListener(SWAP_CHANGED_EVENT, this.load);
    }
    componentWillUnmount() {
        window.removeEventListener(SWAP_CHANGED_EVENT, this.load);
    }
    shown(items) {
        return this.limit > 0 ? items.slice(0, this.state.visible) : items;
    }
    more(items) {
        return this.limit > 0 && this.state.visible < items.length
            ? React.createElement(MoreButton, { onClick: () => this.setState({ visible: this.state.visible + this.limit }) })
            : null;
    }
    /** The question Overtag asks, and what the server answers, over the list. */
    takeDialog() {
        const exchange = this.state.confirmTake;
        if (!exchange)
            return null;
        return React.createElement(AcquireShift, { slug: exchange.slug, question: overtagQuestion(whenText(exchange.shift.dtStart), exchange.shiftMember.name), yesLabel: "Ja, overtag", onClose: () => this.setState({ confirmTake: null }) });
    }
    section(items) {
        var _a;
        const gridElement = (_a = document.getElementById(this.props.elementId)) === null || _a === void 0 ? void 0 : _a.closest(".umb-block-grid__layout-item");
        if (gridElement) {
            gridElement.style.display = items.length === 0 ? "none" : "";
        }
        if (items.length === 0) {
            return React.createElement(React.Fragment, null);
        }
        return (React.createElement("section", { className: "bi-sl-section" },
            React.createElement(SectionHead, { title: "Byttevagter", count: items.length, href: "/byttevagter" }),
            React.createElement("div", { className: "bi-sl-card" },
                this.shown(items).map((exchange, idx) => {
                    const shift = exchange.shift;
                    const start = DateUtility.parse(shift.dtStart);
                    const own = exchange.shiftMember.memberId === this.state.memberUdi;
                    return (React.createElement("div", { className: "bi-xr", key: idx },
                        React.createElement("span", { className: "bi-xr-tile", "aria-hidden": "true" },
                            React.createElement(RoleLabel, { role: exchange.shiftMember.role, iconOnly: true })),
                        React.createElement("a", { className: "bi-xr-text", href: `/byttevagt/?slug=${exchange.slug}` },
                            React.createElement("span", { className: "bi-xr-when" },
                                DateUtility.rowDay(start),
                                " \u00B7 ",
                                start.toFormat("HH:mm")),
                            React.createElement("span", { className: "bi-xr-who" },
                                own ? "Dig" : exchange.shiftMember.name,
                                " \u00B7 ",
                                exchange.shiftMember.role === "Operator" ? "Operatør" : "Kiosk")),
                        own ? null : React.createElement("button", { type: "button", className: "bi-btn bi-btn-take", onClick: () => this.setState({ confirmTake: exchange }) }, "Overtag")));
                }),
                this.more(items)),
            this.takeDialog()));
    }
    render() {
        if (!this.state.isLoaded) {
            return (React.createElement("div", { className: "bp-loading" },
                React.createElement("i", { className: "fa fa-spinner fa-pulse fa-fw" })));
        }
        const items = this.state.items;
        if (this.asSection) {
            return this.section(items);
        }
        return (React.createElement("div", { className: "bi-sl-page" },
            React.createElement(ShiftPageHead, { title: "Byttevagter", subtitle: "Vagter, som en anden frivillig ikke kan tage." },
                React.createElement("div", { className: "bi-seg", role: "group", "aria-label": "Vis byttevagter" },
                    React.createElement("button", { type: "button", "aria-pressed": "true" }, "Alle"),
                    React.createElement("a", { href: "/min-side/mine-byttevagter" }, "Mine byttevagter"))),
            items.length < 1
                ? React.createElement("p", { className: "bi-sl-empty" }, "Der er pt ingen byttevagter")
                : React.createElement(ShiftList, { list: "bytte", items: this.shown(items), start: (exchange) => DateUtility.parse(exchange.shift.dtStart), columns: ["Vagt", "", "Rolle", "Film", "Fra", ""], footer: this.more(items), renderRow: (exchange) => {
                        var _a;
                        const shift = exchange.shift;
                        const own = exchange.shiftMember.memberId === this.state.memberUdi;
                        const events = ((_a = exchange.films) !== null && _a !== void 0 ? _a : []).map((film) => ({ startTime: film.startTime, eventContent: { title: film.title } }));
                        if (own) {
                            return (React.createElement(OwnShiftRow, { href: `/vagtinfo/?shiftId=${shift.id}`, start: DateUtility.parse(shift.dtStart), end: DateUtility.parse(shift.dtEnd), events: events, role: exchange.shiftMember.role, offers: exchange.pendingOffersReceived, offersHref: `/min-side/mine-byttevagter/?slug=${exchange.slug}`, slug: exchange.slug, onCancel: () => this.setState({ confirmCancel: exchange }) }));
                        }
                        return (React.createElement(ShiftRow, { list: "bytte", dots: true, href: `/byttevagt/?slug=${exchange.slug}`, start: DateUtility.parse(shift.dtStart), end: DateUtility.parse(shift.dtEnd), events: events, chevron: false, context: React.createElement(React.Fragment, null,
                                React.createElement(RoleLabel, { role: exchange.shiftMember.role }),
                                React.createElement("span", { className: `bi-sr-from${own ? " bi-sr-from-own" : ""}` },
                                    React.createElement("span", { className: "bi-sr-from-label" }, "fra "),
                                    own ? "dig" : exchange.shiftMember.name)), actions: own ? null : (React.createElement(React.Fragment, null,
                                React.createElement("button", { type: "button", className: "bi-sr-take", onClick: () => this.setState({ confirmTake: exchange }) }, "Overtag"),
                                exchange.canSwap !== false
                                    ? React.createElement("a", { className: "bi-sr-swap", href: `/byttevagt/?slug=${exchange.slug}&swap=1` }, "Byt med mig")
                                    : null)) }));
                    } }),
            this.takeDialog(),
            this.state.confirmCancel
                ? React.createElement(CancelExchangeConfirm, { shiftExchangeId: this.state.confirmCancel.id, shiftMemberId: this.state.confirmCancel.shiftMemberId, onCancelled: () => {
                        this.setState({ confirmCancel: null });
                        // Reloads this list, and tells the others: cancelling can take the shift
                        // out of the volunteer's own offers too.
                        window.dispatchEvent(new CustomEvent(SWAP_CHANGED_EVENT));
                    }, onClose: () => this.setState({ confirmCancel: null }), onError: (message) => this.setState({ confirmCancel: null, error: message }) })
                : null,
            this.state.error ? React.createElement("div", { className: "alert alert-danger" }, this.state.error) : null));
    }
}
// The page of the list is also the page of one byttevagt: with a slug in the address it shows that
// byttevagt instead - the landing page of a shared link and every "Byt med mig" end up here. The
// front page, which shows the list as a section, never has one.
// The page of Mine byttevagter is the other half of the same screen, so it is the same block.
const isMineByttevagter = () => window.location.pathname.toLowerCase().startsWith("/min-side/mine-byttevagter");
ReactRenderer.render("shiftexchangelistcomponent", (elem) => parseAsSection(elem.dataset.assection)
    ? React.createElement(ShiftExchangeListComponent, Object.assign({}, (elem.dataset)))
    : isMineByttevagter()
        ? React.createElement(MyByttevagterPage, Object.assign({}, (elem.dataset)))
        : new URLSearchParams(window.location.search).get("slug")
            ? React.createElement(ShiftExchangeFormComponent, Object.assign({}, (elem.dataset)))
            : React.createElement(ShiftExchangeListComponent, Object.assign({}, (elem.dataset))));
